// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__MhJQY","footer":"ModalCreateQualiphyProcedure_footer__3xZ0d","additionData":"ModalCreateQualiphyProcedure_additionData__3w_g_"};